import { render, staticRenderFns } from "./lang-switcher-simple.vue?vue&type=template&id=8f7cc3c4&scoped=true&"
import script from "./lang-switcher-simple.vue?vue&type=script&lang=js&"
export * from "./lang-switcher-simple.vue?vue&type=script&lang=js&"
import style0 from "./lang-switcher-simple.vue?vue&type=style&index=0&id=8f7cc3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7cc3c4",
  null
  
)

export default component.exports